module.exports = __webpack_public_path__ + "static/media/Timber-Ridge-ByLaws.fba7f064.pdf";